import { DeedType, EducationStage } from '@/types/processing'

import { NewProcessingForm, NewProcessingFormSubmit } from './types'

interface UploadIds {
  adherenceUploadId: string
  selectionUploadId: string
  serviceMapUploadId?: string | null
}

/**
 * Monta o que o modal entrega ao `onSubmit`. PSV-424: `serviceMapUploadId` só
 * entra quando há mapa — sem ele o objeto é idêntico ao de antes, e o backend
 * segue o fluxo atual.
 */
export const buildSubmitPayload = (
  values: NewProcessingForm,
  { adherenceUploadId, selectionUploadId, serviceMapUploadId }: UploadIds
): NewProcessingFormSubmit => ({
  nuDeedType: Number(values.nuDeedType) as DeedType,
  nuEducationStage: Number(values.nuEducationStage) as EducationStage,
  adherenceUploadId,
  selectionUploadId,
  ...(serviceMapUploadId ? { serviceMapUploadId } : {}),
})
